let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dMr3O")).then(() => parcelRequire('bjchh'));